import { ColumnHeader } from '@interfaces/common.model';

export const workingOnHeaders: ColumnHeader[] = [
  { label: 'Product Name', key: 'projectName' },
  { label: 'Start Date', key: 'startDate' },
];

export const workedOnHeaders = [
  { label: 'Product Name', key: 'projectName' },
  { label: 'Start & End Date', key: 'startEndDate' },
];

export const newBeginningsHeaders = [
  { label: 'Event Type', key: 'eventType' },
  { label: 'Submitted On', key: 'created_date' },
  { label: 'Message', key: 'message' },
];
